/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type Availability = "Available" | "ComingSoon" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type cityListPage_query$ref: FragmentReference;
export type cityListPage_query = {|
  +citiesOverview: ?{|
    +cover: ?string,
    +seo: ?{|
      +title: ?string,
      +description: ?string,
    |},
    +social: ?{|
      +twitter: ?$ReadOnlyArray<?{|
        +type: ?string,
        +title: ?string,
        +image: ?string,
        +handle: ?string,
        +description: ?string,
      |}>,
      +generic: ?$ReadOnlyArray<?{|
        +title: ?string,
        +image: ?string,
        +description: ?string,
      |}>,
    |},
  |},
  +cities: $ReadOnlyArray<{|
    +slug: string,
    +name: string,
    +caption: ?string,
    +picture: ?string,
    +color: ?string,
    +featured: ?boolean,
    +availability: Availability,
  |}>,
  +$refType: cityListPage_query$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "cityListPage_query",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "citiesOverview",
      "storageKey": null,
      "args": null,
      "concreteType": "CitiesListPage",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cover",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "seo",
          "storageKey": null,
          "args": null,
          "concreteType": "SEO",
          "plural": false,
          "selections": [
            v0,
            v1
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "social",
          "storageKey": null,
          "args": null,
          "concreteType": "SocialMedia",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "twitter",
              "storageKey": null,
              "args": null,
              "concreteType": "TwtrSlices",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "type",
                  "args": null,
                  "storageKey": null
                },
                v0,
                v2,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "handle",
                  "args": null,
                  "storageKey": null
                },
                v1
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "generic",
              "storageKey": null,
              "args": null,
              "concreteType": "GenSocialSlices",
              "plural": true,
              "selections": [
                v0,
                v2,
                v1
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cities",
      "storageKey": null,
      "args": null,
      "concreteType": "City",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "slug",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "caption",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "picture",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "color",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "featured",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "availability",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '14d9ec05c6290f016e691336ecb6fccc';
module.exports = node;
